import {
  Mail,
  Phone,
  MapPin,
  Clock3,
  Send,
  ShieldCheck,
  Headphones,
  Building2,
} from "lucide-react";
import "../assets/css/contact.css";

export default function Contact() {
  return (
    <main className="contact-page">
      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <span>Contact GMT Technologies</span>
          <h1>Speak with our finance and lending support team</h1>
          <p>
            Have questions about loans, lenders’ plans, repayment structures,
            or partnership opportunities? Our team is ready to guide you.
          </p>
        </div>
      </section>

      {/* CONTACT CARDS */}
      <section className="contact-info-grid">
        <div className="contact-info-card">
          <div className="contact-icon">
            <MapPin size={22} />
          </div>
          <h3>Office Address</h3>
          <p>
            2nd Floor, Wing A, Plot No. 114, Yakubu Gowon Way, Asokoro, Abuja,
            Nigeria
          </p>
        </div>

        <div className="contact-info-card">
          <div className="contact-icon">
            <Phone size={22} />
          </div>
          <h3>Phone Number</h3>
          <p>08126476896</p>
        </div>

        <div className="contact-info-card">
          <div className="contact-icon">
            <Mail size={22} />
          </div>
          <h3>Email Address</h3>
          <p>gmttechnologieslimited@gmail.com</p>
        </div>

        <div className="contact-info-card">
          <div className="contact-icon">
            <Clock3 size={22} />
          </div>
          <h3>Working Hours</h3>
          <p>Monday – Friday, 9:00 am – 5:00 pm</p>
        </div>
      </section>

      {/* FORM + MAP */}
      <section className="contact-main-section">
        <div className="contact-form-panel">
          <span className="section-pill">Send Message</span>
          <h2>Let’s help you move forward</h2>
          <p>
            Fill the form below and our team will contact you as soon as
            possible.
          </p>

          <form>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input id="name" type="text" placeholder="Enter your full name" />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input id="email" type="email" placeholder="Enter your email" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input id="phone" type="text" placeholder="Enter phone number" />
              </div>

              <div className="form-group">
                <label htmlFor="interest">I am interested in</label>
                <select id="interest">
                  <option>Loan Services</option>
                  <option>Lenders Plans</option>
                  <option>Financial Advisory</option>
                  <option>Partnership</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input id="subject" type="text" placeholder="Message subject" />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                placeholder="Tell us how we can help"
                rows={6}
              />
            </div>

            <button type="submit" className="contact-submit-btn">
              Send Message <Send size={17} />
            </button>
          </form>
        </div>

        <div className="contact-map-panel">
          <div className="map-card">
            <iframe
              title="GMT Technologies Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.23398010886!2d7.519334388854975!3d9.042408900000009!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e095f0c5e4e59%3A0x1774f360cd35f761!2sECOWAS%20Secretariat!5e0!3m2!1sen!2sng!4v1769739320702!5m2!1sen!2sng"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>

          <div className="contact-assurance-card">
            <h3>Reliable support for every customer</h3>

            <div>
              <ShieldCheck size={20} />
              Secure and transparent communication
            </div>

            <div>
              <Headphones size={20} />
              Human support for loans and investment enquiries
            </div>

            <div>
              <Building2 size={20} />
              Office support available in Asokoro, Abuja
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}